const MAX_SUBSCRIPTION_NUMBER = 100;

export { MAX_SUBSCRIPTION_NUMBER }